import { Link } from "wouter";
import CustomLink from "./CustomLink";
import { Facebook, Twitter, Instagram, Youtube } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();
  
  return (
    <footer className="bg-[#333333] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Column 1 - About */}
          <div>
            <h3 className="font-poppins font-bold text-xl mb-4">Turkish Vacation Guide</h3>
            <p className="text-gray-300 mb-4">
              Your comprehensive resource for exploring the wonders of Turkey, from ancient ruins to modern attractions.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/turkeyvacationguide" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#E30A17] transition duration-200" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://x.com/turkeyguide" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#E30A17] transition duration-200" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="https://www.instagram.com/turkeyvacationguide" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#E30A17] transition duration-200" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://www.youtube.com/@turkeyvacationguide" target="_blank" rel="noopener noreferrer" className="text-white hover:text-[#E30A17] transition duration-200" aria-label="YouTube">
                <Youtube size={20} />
              </a>
            </div>
          </div>
          
          {/* Column 2 - Destinations */}
          <div>
            <h3 className="font-poppins font-bold mb-4">Destinations</h3>
            <ul className="space-y-2">
              <li>
                <CustomLink href="/destinations/istanbul" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Istanbul
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/destinations/cappadocia" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Cappadocia
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/destinations/antalya" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Antalya
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/destinations/ephesus" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Ephesus
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/destinations/pamukkale" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Pamukkale
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/destinations/bodrum" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Bodrum
                </CustomLink>
              </li>
            </ul>
          </div>
          
          {/* Column 3 - Travel Resources */}
          <div>
            <h3 className="font-poppins font-bold mb-4">Travel Resources</h3>
            <ul className="space-y-2">
              <li>
                <CustomLink href="/transportation" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Transportation
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/accommodation" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Accommodation
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/cuisine" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Food & Drink
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/culture" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Cultural Tips
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/language-guide" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Language Guide
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/practical-info" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Practical Info
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/practical-info#itineraries" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Itineraries
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/budget-calculator" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Budget Calculator
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/packing-checklist" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Packing Checklist
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/business-directory" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Business Directory
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/community-forum" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Community Forum
                </CustomLink>
              </li>
            </ul>
          </div>
          
          {/* Column 4 - About */}
          <div>
            <h3 className="font-poppins font-bold mb-4">About</h3>
            <ul className="space-y-2">
              <li>
                <CustomLink href="/about-us" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  About Us
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/contact" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Contact
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/faq" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  FAQ
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/privacy-policy" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Privacy Policy
                </CustomLink>
              </li>
              <li>
                <CustomLink href="/terms-of-use" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Terms of Use
                </CustomLink>
              </li>
              <li>
                <a href="/sitemap.xml" className="text-gray-300 hover:text-[#E30A17] transition duration-200">
                  Sitemap
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {year} Turkish Vacation Guide. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
